import { render, staticRenderFns } from "./WF2_GreatNews.vue?vue&type=template&id=3d5aef54&scoped=true"
import script from "./WF2_GreatNews.vue?vue&type=script&lang=js"
export * from "./WF2_GreatNews.vue?vue&type=script&lang=js"
import style0 from "./WF2_GreatNews.vue?vue&type=style&index=0&id=3d5aef54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5aef54",
  null
  
)

export default component.exports